export const masterFirebaseConfig = {
  apiKey: "AIzaSyD3IZmR95ZE3xc0pdKEwQIth_9-BJPjrHI",
  authDomain: "abel-trotter-portfolio.firebaseapp.com",
  databaseURL: "https://abel-trotter-portfolio.firebaseio.com",
  projectId: "abel-trotter-portfolio",
  storageBucket: "abel-trotter-portfolio.appspot.com",
  messagingSenderId: "798314093000"
};


// WEBPACK FOOTER //
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/api-keys.ts